'use strict';

require('./FormGroupImageChooser.scss');

const React = require('react'),
    PropTypes = React.PropTypes,
    BasicFormGroup = require('../BasicFormGroup'),
    _ = require('lodash'),
    Uploader = require('components/Commons/Uploader/Uploader');

const FormGroupImageChooser = React.createClass({displayName: "FormGroupImageChooser",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        placeHolder: PropTypes.string,
        label: PropTypes.string,
        onChange: PropTypes.func,
        messageError: PropTypes.string,
        isRequired: PropTypes.bool,
        isDisabled: PropTypes.bool
    }),

    componentDidMount() {
        var {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    clean() {
        this.refs.inputImage.setValue('');
    },

    getValue() {
        var {writerAttribute} = this.props;
        var value = this.refs.inputImage.getValue();
        var wrapper = {};

        wrapper = _.set(wrapper, writerAttribute, value);
        return wrapper;
    },

    isValid() {
        this.setState({messageError: ''});
        return true;
    },

    render() {
        return (
            React.createElement("div", {className: "form-group form-group-image-chooser"}, 
                React.createElement(Uploader, {isDisable: this.props.isDisabled, label: this.props.label, ref: "inputImage"}
                )
            )
        );
    }
});

module.exports = FormGroupImageChooser;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupImageChooser/FormGroupImageChooser.jsx
 **/